export const fields = [
  { key: 'load_date', format: true },
  { key: 'date_unloaded', format: true },
  { key: 'brand' },
  { key: 'state_numbers' },
  { key: 'state_numbers_trailer' },
  { key: 'carrier_name' },
  { key: 'carrier_inn' },
  { key: 'fio' },
  { key: 'brutto_ttn', weight: true },
  { key: 'tara_ttn', weight: true },
  { key: 'netto_ttn', weight: true },
  { key: 'brutto_fact', weight: true },
  { key: 'tara_fact', weight: true },
  { key: 'netto_fact', weight: true },
  { key: 'ttns', arr: true },
  { key: 'dogovor' },
  { key: 'empty' },
  { key: 'empty' },
  { key: 'empty' },
  { key: 'act_number' },
  { key: 'act_date', format: true },
  { key: 'act_sum', last: true, num: true },
]
